'use client'

import { useTranslation } from 'react-i18next'
import { Box, Grid, Typography } from '@mui/material'

import { CamplusLogo } from '@/src/components/ui/CamplusLogo'

const SOCIALS = [
  {
    name: 'facebook',
    icon: 'ico-facebook',
    url: 'https://www.facebook.com/CamplusLife/'
  },
  {
    name: 'instagram',
    icon: 'ico-instagram',
    url: 'https://www.instagram.com/campluslife/'
  },
  {
    name: 'linkedin',
    icon: 'ico-linkedin',
    url: 'https://www.linkedin.com/company/camplus-bologna/'
  },
  {
    name: 'youtube',
    icon: 'ico-youtube',
    url: 'https://www.youtube.com/channel/UCfRyhYh8AXmSlbtMvy1jcyw'
  }
] as const

export const BookingFooter: React.FC = () => {
  const { t } = useTranslation()

  return (
    <Box
      component="footer"
      sx={{
        bgcolor: 'primary.main',
        color: 'white',
        py: { xs: 5, md: 10 },
        px: { xs: 3, md: 12.5 }
      }}
    >
      {/* Logo + info */}
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 5 }}>
        <CamplusLogo width={120} />
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
          {/* Social icons */}
          <Box sx={{ display: 'flex' }}>
            {SOCIALS.map((social) => (
              <Box
                key={social.name}
                component="a"
                href={social.url}
                target="_blank"
                rel="noopener noreferrer"
                sx={{
                  '&:not(:first-of-type)': { ml: '-1px' },
                  width: '5rem',
                  height: '5rem',
                  border: '1px solid rgba(255, 255, 255, 0.1)',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  cursor: 'pointer',
                  transition: 'all 0.2s',
                  '&:hover': {
                    backgroundColor: 'rgba(255, 255, 255, 0.1)'
                  }
                }}
              >
                <svg width={16} height={16} style={{ color: 'white' }}>
                  <use href={`/images/icons-sprite.svg#${social.icon}`} />
                </svg>
              </Box>
            ))}
          </Box>
          <Grid container spacing={2}>
            <Grid size={{ xs: 12, md: 6 }}>
              <Typography
                sx={{
                  fontFamily: '"Barlow Condensed", sans-serif',
                  fontWeight: 600,
                  fontSize: '1.2rem',
                  letterSpacing: '0.05em'
                }}
              >
                {t('footer.copyright', { year: new Date().getFullYear() })}
              </Typography>
            </Grid>
            <Grid
              size={{
                xs: 12,
                md: 6
              }}
            >
              <Box
                sx={{
                  display: 'flex',
                  gap: 2,
                  justifyContent: { xs: 'flex-start', md: 'flex-end' }
                }}
              >
                {[
                  {
                    key: 'privacy',
                    label: t('footer.privacy'),
                    url: 'https://www.camplus.it/informativa-privacy/'
                  },
                  {
                    key: 'cookies',
                    label: t('footer.cookies'),
                    url: 'https://www.camplus.it/cookie/'
                  }
                ].map((item) => (
                  <Typography
                    key={item.key}
                    component="a"
                    href={item.url}
                    sx={{
                      fontFamily: '"Barlow Condensed", sans-serif',
                      fontWeight: 600,
                      fontSize: '1.2rem',
                      color: 'rgba(255, 255, 255, 0.7)',
                      textDecoration: 'none',
                      '&:hover': { color: 'white' },
                      transition: 'color 0.2s'
                    }}
                  >
                    {item.label}
                  </Typography>
                ))}
              </Box>
            </Grid>
          </Grid>
        </Box>
      </Box>
    </Box>
  )
}
